import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstanceAuth } from "../../../Utils/AxiosInstance";
import { revertAll } from "../ResetStateAction";

const initialState = {
  Module: [],
  isSuccess: false,
  message: null,
  status: "idle", // idle | loading | succeeded | failed
  error: null,
};

export const fetchModule = createAsyncThunk("/Module/Get", async () => {
  const response = await axiosInstanceAuth.get(`/Subscription/GetModule`);
  return response.data;
});

export const addOrUpdateModule = createAsyncThunk("/Module/AddOrUpdate", async obj => {
  const response = await axiosInstanceAuth.post(`/Subscription/AddUpdateModule`, obj);
  return response.data;
});

const ModuleSlice = createSlice({
  name: "Module",
  initialState,
  reducers: {
    resetModuleState: state => {
      state.Module = [];
      state.isSuccess = false;
      state.message = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(revertAll, () => initialState)

      .addCase(fetchModule.pending, state => {
        state.status = "loading";
      })
      .addCase(fetchModule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;
        state.Module = action.payload.Data;
      })
      .addCase(fetchModule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      .addCase(addOrUpdateModule.pending, state => {
        state.status = "loading";
      })
      .addCase(addOrUpdateModule.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.message = action.payload.Message;
        state.isSuccess = action.payload.IsSuccess;

        if (action.payload.Data) {
          state.Module = action.payload.Data;
        }
      })
      .addCase(addOrUpdateModule.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export const getModuleDetails = state => state.Module;

export const { resetModuleState } = ModuleSlice.actions;

export default ModuleSlice.reducer;
